import { IRootState } from '../../../store'

export const getUpgradeStatus = (state: IRootState): string => state.home.upgradeStatus
